export const testimonial = [
  {
    testimonial:
      "This platform exceeded my expectations. The user interface is intuitive, vehicle details are accurate, and the support team is incredibly responsive throughout the entire purchase process.",
    name: "Rajesh Sharma",
    position: "Verified Buyer",
    rating: 5,
  },
  {
    testimonial:
      "Finding and purchasing my car through Kaizen Motor was a seamless experience. Outstanding service, transparent pricing, and prompt delivery right to my doorstep!",
    name: "Vikram Malhotra",
    position: "Car Enthusiast",
    rating: 5,
  },
  {
    testimonial:
      "Absolutely love using this service! It made selling my old car and upgrading to a premium vehicle effortless and fast. Highly recommended to everyone looking for quality cars.",
    name: "Ananya Verma",
    position: "Verified Customer",
    rating: 5,
  },
  {
    testimonial:
      "The vehicle quality and 360-degree inspection reports gave me complete confidence. Truly the most reliable and transparent automotive platform I have used.",
    name: "Rohan Kulkarni",
    position: "Verified Buyer",
    rating: 5,
  },
  {
    testimonial:
      "Exceptional customer experience from start to finish. The team guided me at every step and made owning my dream car an effortless, transparent, and joyful journey.",
    name: "Priya Mehra",
    position: "Premium Car Owner",
    rating: 5,
  },
];
